import * as types from '../mutation-types'
import api from '../api'
import Vue from 'vue'

const getDefaultUserState = () => {
  return {
        // user raw data from api
        me: {},
        mePromise: null,
        agencies: []
  }
}

const state = getDefaultUserState()

const mutations = {
    [types.USER_DATA_RECEIVED] (state, payload) {
        Vue.set(state, "me", payload)
    },
    
    [types.SET_ME_PROMISE] (state, promise) {
        Vue.set(state, "mePromise", promise)
    },
    
    [types.RESET_ME_PROMISE] (state) {
        Vue.set(state, "mePromise", null)
    },

    [types.USER_AGENCIES_RECEIVED] (state, payload) {
        Vue.set(state, "agencies", payload)
    },
    resetUserState (state) {
      Object.assign(state, getDefaultUserState())
    }
}

const actions = {
    resetUserState ({ commit }) {
      commit('resetUserState')
    },

    getLoggedUser ({state, commit}) {
        if (Object.keys(state.me).length > 0) {
            return state.me
        }
        
        if (state.mePromise) {
            return state.mePromise
        }

        let promise = api.getLoggedUser()
            .then(response => commit(types.USER_DATA_RECEIVED, response.data))
        
        commit(types.SET_ME_PROMISE, promise)

        return promise
    },

    getUserAgencies ({commit}) {
        return api.getUserAgencies(state.me.id)
            .then(response => commit(types.USER_AGENCIES_RECEIVED, response.data.agencies))
    },

    getUser({ commit }, userId) {
        return api.getUser(userId)
    },
}

const getters = {
    isAdmin (state) {
        return state.me.hasOwnProperty('admin') && state.me.admin
    },

    isUserManager(state) {
        let myRoles = []

        if (state.me.hasOwnProperty('roles') && Array.isArray(state.me.roles)) {
            myRoles = Array.from(state.me.roles, role => role.name)
        }

        return myRoles.includes('user-manager')
    },

    isAgency (state) {
        let myRoles = []

        if (state.me.hasOwnProperty('roles') && Array.isArray(state.me.roles)) {
            myRoles = Array.from(state.me.roles, role => role.name)
        }

        if (myRoles.length === 1) {
            return true
        } else if (myRoles.length > 1) {
            return myRoles.includes('premium-agency')
        }

        return false
    },
}

export default {
    state,
    mutations,
    actions,
    getters,
}



// WEBPACK FOOTER //
// ./client/store/modules/user.js